import React, { useEffect } from "react"
import { useMapEvents, useMap } from "react-leaflet"

interface ClickHandlerProps {
  onPick: (lat: number, lng: number) => void
}

export const ClickHandler: React.FC<ClickHandlerProps> = ({ onPick }) => {
  useMapEvents({
    click(e) {
      onPick(e.latlng.lat, e.latlng.lng)
    },
  })
  return null
}

interface FlyToProps {
  lat: number
  lng: number
}

export const FlyTo: React.FC<FlyToProps> = ({ lat, lng }) => {
  const map = useMap()
  useEffect(() => {
    map.flyTo([lat, lng], 15, { duration: 1.4 })
  }, [lat, lng, map])
  return null
}

export const MapResizer: React.FC = () => {
  const map = useMap()
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 300)
    return () => clearTimeout(t)
  }, [map])
  return null
}